/**
* @summary - Component that Provides Hospital Information Tab
* @author Yuvasri S
* @since 2024-07-04
*/
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField, Grid, Box, Button, IconButton, Typography } from '@mui/material';
import TabContentLayout from './TabContentLayout';
import { updateHospitalInformation, setMashospitaldetailsId } from '../../redux/reducers/HospitalInformationReducer/formSlice'; // Import setMashospitaldetailsId
import { DefaultCard } from '../../assets/styled-components/card';
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import CustomTextField from '../commoncomponents/CustomTextField';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import { getAuthToken, getcompanyId, getCreatedBy } from "../../utility/tokenUtility";
import { MasterGraph, ifacSecurityURL } from '../../utility/apiURLS';
import axios from "axios";
import CustomDialog from '../commoncomponents/CustomDialog';
import { BreadcrumbBar } from '../../assets/styled-components/breadcrumbBar';
import HomeIconButton from '../commoncomponents/HomeIconButton';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router";

function HospitalInformationContent({ hospitalInformation, onHospitalInfoChange, isViewMode, tabValue }) {
  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const companyId = getcompanyId('companyId');
  const createdBy = getCreatedBy('createdBy');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    hospitalcode,
    hospitalname,
    locationflag,
    hospitaltype,
    directorname,
    state,
    address,
    postcode,
    telephoneno,
    emailaddress,
    faxno,
    branchmanager,
    handphoneno,
    telephonenum,
    faxnum,
    hospitalGroupId,
    clsvorate
  } = hospitalInformation;

  const [hospitalCodeOptions, setHospitalCodeOptions] = useState([]);
  const [locationFlagOptions, setLocationFlagOptions] = useState([]);
  const [hospitalTypeOptions, setHospitalTypeOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const [hospitalDetailsId, setHospitalDetailsId] = useState(null);
  const hospitalDetailsIdd = useSelector((state) => state.form.mashospitaldetailsId);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [succesDialogMessage, setSuccessDialogMessage] = useState('');
  const [errors, setErrors] = useState({
    hospitalcode: false, hospitalname: false, locationflag: false, hospitaltype: false, state: false, emailaddress: false
  });

  const [errorMessages, setErrorMessages] = useState({
    hospitalcode: '', hospitalname: '', locationflag: '', hospitaltype: '', state: '', emailaddress: ''
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const fetchHospitalCodeOptions = async () => {
    try {
      const response = await axios.get(`${ifacSecurityURL}/api/GraphUserdetails/Locationbasedoncompantid/${companyId}?size=1000`, config);
      const hospitalCodeData = response.data;

      const options = hospitalCodeData.map(code => ({
        value: code.facilityname,
        label: `${code.facilitycode} - ${code.facilityname}`,
        id: code.id
      }));

      setHospitalCodeOptions(options);
    } catch (error) {
      console.error("Error fetching Hospital Code options:", error);
    }
  };

  const fetchLocationFlagOptions = async () => {
    try {
      const response = await axios.get(`${MasterGraph}/api/mashospitallocationflags`, config);
      const locationFlagData = response.data;
      const options = locationFlagData.map(locationflag => ({
        value: locationflag.locationFlag,
        label: locationflag.locationFlag,
        id: locationflag.id
      }));
      setLocationFlagOptions(options);
    } catch (error) {
      console.error("Error fetching location flag options:", error);
    }
  };

  const fetchHospitalTypeOptions = async () => {
    try {
      const response = await axios.get(`${MasterGraph}/api/mashospitaltypes`, config);
      const hospitalTypeData = response.data;
      const options = hospitalTypeData.map(hospitaltype => ({
        value: hospitaltype.hospType,
        label: hospitaltype.hospType,
        id: hospitaltype.id
      }));
      setHospitalTypeOptions(options);
    } catch (error) {
      console.error("Error fetching hospital type options:", error);
    }
  };
  const fetchStateOptions = async () => {
    try {
      const response = await axios.get(`${ifacSecurityURL}/api/secstatemasters`, config);
      const stateData = response.data;
      const options = stateData.map(state => ({
        value: state.statename,
        label: state.statename,
        id: state.id
      }));
      setStateOptions(options);
    } catch (error) {
      console.error("Error fetching hospital type options:", error);
    }
  };

  const fetchHospitalDetails = async (facilityId) => {
    try {
      const response = await axios.get(`${MasterGraph}/api/GraphHospitalMaster/GetHospitalMasterByFacilityId/${facilityId}`, config);
      const hospitalDetailsArray = response.data;
      if (hospitalDetailsArray.length > 0) {
        const hospitalDetails = hospitalDetailsArray[0];

        let locationflag = {};
        let hospitaltype = {};
        locationflag = {
          value: hospitalDetails.mashospitallocationflag.locationFlag,
          id: hospitalDetails.mashospitallocationflag.id,
          label: hospitalDetails.mashospitallocationflag.locationFlag
        };

        hospitaltype = {
          value: hospitalDetails.mashospitaltype.hospType,
          id: hospitalDetails.mashospitaltype.id,
          label: hospitalDetails.mashospitaltype.hospType
        };

        let state = {};
        if (hospitalDetails.stateid) {
          state = stateOptions.find(option => option.id === hospitalDetails.stateid) || {};
        }


        onHospitalInfoChange({
          locationflag: locationflag || '',
          hospitaltype: hospitaltype || '',
          directorname: hospitalDetails.directorname || '',
          state: state || '',
          address: hospitalDetails.address || '',
          postcode: hospitalDetails.postcode || '',
          telephoneno: hospitalDetails.hosptelephoneno || '',
          emailaddress: hospitalDetails.hospemail || '',
          faxno: hospitalDetails.hospfaxno || '',
          branchmanager: hospitalDetails.contbranchmgr || '',
          handphoneno: hospitalDetails.conthandphno || '',
          telephonenum: hospitalDetails.conttelephone || '',
          faxnum: hospitalDetails.contfaxno || '',
          hospitalGroupId: hospitalDetails.mashospitalgroupId || '',
          clsvorate: hospitalDetails.clsvorate || ''
        });

        dispatch(updateHospitalInformation({
          locationflag: locationflag || '',
          hospitaltype: hospitaltype || '',
          directorname: hospitalDetails.directorname || '',
          state: hospitalDetails.stateid || '',
          address: hospitalDetails.address || '',
          postcode: hospitalDetails.postcode || '',
          telephoneno: hospitalDetails.hosptelephoneno || '',
          emailaddress: hospitalDetails.hospemail || '',
          faxno: hospitalDetails.hospfaxno || '',
          branchmanager: hospitalDetails.contbranchmgr || '',
          handphoneno: hospitalDetails.conthandphno || '',
          telephonenum: hospitalDetails.conttelephone || '',
          faxnum: hospitalDetails.contfaxno || '',
          hospitalGroupId: hospitalDetails.mashospitalgroupId || '',
          clsvorate: hospitalDetails.clsvorate || ''
        }));

        setHospitalDetailsId(hospitalDetails.id);
        dispatch(setMashospitaldetailsId(hospitalDetails.id));
        // Clear errors if new values are fetched
        setErrors((prevErrors) => ({
          ...prevErrors,
          locationflag: false,
          hospitaltype: false,
          state: false,
        }));

        setErrorMessages((prevMessages) => ({
          ...prevMessages,
          locationflag: '',
          hospitaltype: '',
          state: '',
        }));
      } else {
        console.error("No hospital details found for the given facility ID");
        setDialogOpen(true);
        onHospitalInfoChange({
          locationflag: '',
          hospitaltype: '',
          directorname: '',
          state: '',
          address: '',
          postcode: '',
          telephoneno: '',
          emailaddress: '',
          faxno: '',
          branchmanager: '',
          handphoneno: '',
          telephonenum: '',
          faxnum: '',
          hospitalGroupId: '',
          clsvorate: ''
        });
        dispatch(updateHospitalInformation({
          locationflag: '',
          hospitaltype: '',
          directorname: '',
          state: '',
          address: '',
          postcode: '',
          telephoneno: '',
          emailaddress: '',
          faxno: '',
          branchmanager: '',
          handphoneno: '',
          telephonenum: '',
          faxnum: '',
          hospitalGroupId: '',
          clsvorate: ''
        }));
        setHospitalDetailsId('');
        dispatch(setMashospitaldetailsId(null));
      }
    } catch (error) {
      console.error("Error fetching Hospital Details:", error);
      onHospitalInfoChange({
        locationflag: '',
        hospitaltype: '',
        directorname: '',
        state: '',
        address: '',
        postcode: '',
        telephoneno: '',
        emailaddress: '',
        faxno: '',
        branchmanager: '',
        handphoneno: '',
        telephonenum: '',
        faxnum: '',
        hospitalGroupId: '',
        clsvorate: ''
      });
      dispatch(updateHospitalInformation({
        locationflag: '',
        hospitaltype: '',
        directorname: '',
        state: '',
        address: '',
        postcode: '',
        telephoneno: '',
        emailaddress: '',
        faxno: '',
        branchmanager: '',
        handphoneno: '',
        telephonenum: '',
        faxnum: '',
        hospitalGroupId: '',
        clsvorate: ''
      }));
    }
  };

  useEffect(() => {
    if (hospitalDetailsId !== null) {
      console.log('Updated hospitalDetailsId:', hospitalDetailsId);
    }
  }, [hospitalDetailsId]);

  useEffect(() => {
    fetchHospitalCodeOptions();
    fetchLocationFlagOptions();
    fetchHospitalTypeOptions();
    fetchStateOptions();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    let formIsValid = true;
    const newErrors = { hospitalcode: false, hospitalname: false, locationflag: false, hospitaltype: false, state: false, emailaddress: false };
    const newErrorMessages = { hospitalcode: '', hospitalname: '', locationflag: '', hospitaltype: '', state: '', emailaddress: '' };


    if (!hospitalcode) {
      formIsValid = false;
      newErrors.hospitalcode = true;
      newErrorMessages.hospitalcode = 'Hospital Code is required';
      newErrors.categoryDesc = true;
      newErrorMessages.categoryDesc = 'Hospital Name is required';
    }
    if (!locationflag) {
      formIsValid = false;
      newErrors.locationflag = true;
      newErrorMessages.locationflag = 'Location Flag is required';
    }
    if (!hospitaltype) {
      formIsValid = false;
      newErrors.hospitaltype = true;
      newErrorMessages.hospitaltype = 'Hospital Type is required';
    }
    if (!state) {
      formIsValid = false;
      newErrors.state = true;
      newErrorMessages.state = 'State is required';
    }
    if (emailaddress && !emailRegex.test(emailaddress)) {
      formIsValid = false;
      newErrors.emailaddress = true;
      newErrorMessages.emailaddress = 'Invalid email address';
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    if (formIsValid) {
      handleSave();
      setHasUnsavedChanges(false);
    }
  };

  const handleSave = async () => {
    try {
      const payload = {
        createdby: createdBy,
        facilityid: hospitalcode.id,
        hospitalname: hospitalcode.value,
        directorname: directorname,
        stateid: state.id,
        address1: address,
        postcode: postcode,
        hosptelephoneno: telephoneno,
        hospemail: emailaddress,
        hospfaxno: faxno,
        contbranchmgr: branchmanager,
        conthandphno: handphoneno,
        conttelephone: telephonenum,
        contfaxno: faxnum,
        mashospitallocationflag: {
          id: locationflag.id,
          locationFlag: locationflag.value,
          isvisible: true
        },
        mashospitaltype: {
          id: hospitaltype.id,
          hospType: hospitaltype.value,
          isvisible: true
        },
        id: hospitalDetailsIdd,
        MashospitalgroupId: hospitalGroupId,
        Clsvorate: clsvorate
      };

      // Determine whether to make a POST or PUT request
      if (hospitalDetailsIdd) {
        // PUT request
        const putUrl = `${MasterGraph}/api/mashospitaldetails/${hospitalDetailsIdd}`;
        await axios.put(putUrl, payload, config);
        setSuccessDialogMessage('Data updated successfully.');
      } else {
        // POST request
        const response = await axios.post(`${MasterGraph}/api/mashospitaldetails`, payload, config);
        const savedDataId = response.data.id;
        dispatch(setMashospitaldetailsId(savedDataId));
        setSuccessDialogMessage('Data saved successfully.');
      }

      // Update state or dispatch actions as needed
      dispatch(updateHospitalInformation({
        locationflag,
        hospitaltype,
        directorname,
        state,
        address,
        postcode,
        telephoneno,
        emailaddress,
        faxno,
        branchmanager,
        handphoneno,
        telephonenum,
        faxnum
      }));

      // Additional state updates if required

      // Open success dialog
      setSuccessDialogOpen(true);

    } catch (error) {
      console.error("Error saving Hospital Information:", error);
    }
  };

  const handleCancel = () => {
    if (hasUnsavedChanges && !isViewMode) {
      setCancelDialogOpen(true);
    } else {
      navigate(-1, { replace: true });
    }
  };

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleCancelDialogConfirm = () => {
    setCancelDialogOpen(false);
    navigate(-1, { replace: true });
  };



  const handleChange = (field, newValue) => {
    setHasUnsavedChanges(true); // Flagging that there are unsaved changes
    switch (field) {
      case 'hospitalcode':
        const trimmedCategory = (newValue ? { ...newValue, label: newValue.label.split(' ')[0].trimRight() } : '');

        // Update hospital code and name
        onHospitalInfoChange({
          hospitalcode: trimmedCategory,
          hospitalname: newValue ? newValue.value : '', // Update hospitalname if newValue exists
          hospitalid: newValue ? newValue.id : '',

        });
        dispatch(updateHospitalInformation({
          hospitalcode: trimmedCategory,
          hospitalname: newValue ? newValue.value : '',
          hospitalid: newValue ? newValue.id : ''
        }));
        if (newValue) {
          setErrors((prevErrors) => ({ ...prevErrors, hospitalcode: false, hospitalname: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalcode: '', hospitalname: '' }));
        }
        if (newValue && newValue.id) {
          fetchHospitalDetails(newValue.id);
        }
        else {
          // Reset all fields if hospitalcode is null or empty
          onHospitalInfoChange({
            hospitalcode: '',
            hospitalname: '',
            hospitalid: '',
            locationflag: '',
            hospitaltype: '',
            directorname: '',
            state: '',
            address: '',
            postcode: '',
            telephoneno: '',
            emailaddress: '',
            faxno: '',
            branchmanager: '',
            handphoneno: '',
            telephonenum: '',
            faxnum: '',
          });
          dispatch(updateHospitalInformation({
            hospitalcode: '',
            hospitalname: '',
            hospitalid: '',
            locationflag: '',
            hospitaltype: '',
            directorname: '',
            state: '',
            address: '',
            postcode: '',
            telephoneno: '',
            emailaddress: '',
            faxno: '',
            branchmanager: '',
            handphoneno: '',
            telephonenum: '',
            faxnum: '',
          }));
          setHospitalDetailsId(null);
          dispatch(setMashospitaldetailsId(null));
        }
        // Also update locationflag and hospitaltype based on hospitalcode selection
        if (newValue && newValue.locationflag && newValue.hospitaltype) {
          onHospitalInfoChange({
            locationflag: newValue ? newValue.locationflag : '',
            hospitaltype: newValue ? newValue.hospitaltype : ''
          });
          dispatch(updateHospitalInformation({
            locationflag: newValue ? newValue.locationflag : '',
            hospitaltype: newValue ? newValue.hospitaltype : ''
          }));
        }
        break;
      case 'locationflag':
        onHospitalInfoChange({ locationflag: newValue });
        dispatch(updateHospitalInformation({ locationflag: newValue }));
        if (newValue) {
          setErrors((prevErrors) => ({ ...prevErrors, locationflag: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, locationflag: '' }));
        }
        break;
      case 'hospitaltype':
        onHospitalInfoChange({ hospitaltype: newValue });
        dispatch(updateHospitalInformation({ hospitaltype: newValue }));
        if (newValue) {
          setErrors((prevErrors) => ({ ...prevErrors, hospitaltype: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, hospitaltype: '' }));
        }
        break;
      case 'directorname':
        onHospitalInfoChange({ directorname: newValue });
        dispatch(updateHospitalInformation({ directorname: newValue }));
        break;
      case 'state':
        onHospitalInfoChange({ state: newValue });
        dispatch(updateHospitalInformation({ state: newValue }));
        if (newValue) {
          setErrors((prevErrors) => ({ ...prevErrors, state: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, state: '' }));
        }
        break;
      case 'address':
        onHospitalInfoChange({ address: newValue });
        dispatch(updateHospitalInformation({ address: newValue }));
        break;
      case 'postcode':
        onHospitalInfoChange({ postcode: newValue });
        dispatch(updateHospitalInformation({ postcode: newValue }));
        break;
      case 'telephoneno':
        onHospitalInfoChange({ telephoneno: newValue });
        dispatch(updateHospitalInformation({ telephoneno: newValue }));
        break;
      case 'emailaddress':
        onHospitalInfoChange({ emailaddress: newValue });
        dispatch(updateHospitalInformation({ emailaddress: newValue }));

        // Validate email address
        if (newValue && !emailRegex.test(newValue)) {
          setErrors((prevErrors) => ({ ...prevErrors, emailaddress: true }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, emailaddress: 'Invalid email address' }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, emailaddress: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, emailaddress: '' }));
        }
        break;
      case 'faxno':
        onHospitalInfoChange({ faxno: newValue });
        dispatch(updateHospitalInformation({ faxno: newValue }));
        break;
      case 'branchmanager':
        onHospitalInfoChange({ branchmanager: newValue });
        dispatch(updateHospitalInformation({ branchmanager: newValue }));
        break;
      case 'handphoneno':
        onHospitalInfoChange({ handphoneno: newValue });
        dispatch(updateHospitalInformation({ handphoneno: newValue }));
        break;
      case 'telephonenum':
        onHospitalInfoChange({ telephonenum: newValue });
        dispatch(updateHospitalInformation({ telephonenum: newValue }));
        break;
      case 'faxnum':
        onHospitalInfoChange({ faxnum: newValue });
        dispatch(updateHospitalInformation({ faxnum: newValue }));
        break;
      default:
        break;
    }
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogConfirm = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    fetchHospitalDetails(hospitalcode.id);
  }, [tabValue]);
  return (
    <TabContentLayout>
      <DefaultCard sx={{ height: '100%' }}>
        <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
          <Box mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <CustomTextFieldWithSearch
                  label="Hospital Code"
                  id="hospital-code"
                  value={hospitalcode}
                  options={hospitalCodeOptions}
                  onChange={(newValue) => handleChange('hospitalcode', newValue)}
                  disabled={isViewMode}
                  maxlength={30}
                  isMandatoryField={true}
                  error={errors.hospitalcode}
                  errorMessage={errorMessages.hospitalcode}
                  autoFocus={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={40}
                  label="Hospital Name"
                  id="hospital-name"
                  value={hospitalname}
                  onChange={(newValue) => handleChange('hospitalname', newValue)}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomSelectInput
                  maxlength={10}
                  id="location-flag"
                  label="Location Flag"
                  value={locationflag}
                  options={locationFlagOptions}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(newValue) => handleChange('locationflag', newValue)}
                  disabled={isViewMode}
                  isMandatoryField={true}
                  error={errors.locationflag}
                  errorMessage={errorMessages.locationflag}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomSelectInput
                  maxlength={10}
                  id="hospital-type"
                  label="Hospital Type"
                  value={hospitaltype}
                  options={hospitalTypeOptions}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(newValue) => handleChange('hospitaltype', newValue)}
                  disabled={isViewMode}
                  isMandatoryField={true}
                  error={errors.hospitaltype}
                  errorMessage={errorMessages.hospitaltype}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  label="Director's Name"
                  id="director-name"
                  value={directorname}
                  onChange={(newValue) => handleChange('directorname', newValue)}
                  disabled={isViewMode}
                  maxlength={40}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomSelectInput
                  maxlength={10}
                  id="state"
                  label="State"
                  value={state}
                  options={stateOptions}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(newValue) => handleChange('state', newValue)}
                  disabled={isViewMode}
                  isMandatoryField={true}
                  error={errors.state}
                  errorMessage={errorMessages.state}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomTextArea
                  label="Address"
                  id="address"
                  value={address}
                  onChange={(newValue) => handleChange('address', newValue)}
                  disabled={isViewMode}
                  maxlength={180}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={10}
                  label="Post Code"
                  id="post-code"
                  value={postcode}
                  onChange={(newValue) => handleChange('postcode', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={20}
                  label="Telephone No"
                  id="telephone-no"
                  value={telephoneno}
                  onChange={(newValue) => handleChange('telephoneno', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={60}
                  label="Email Address"
                  id="email-address"
                  value={emailaddress}
                  onChange={(newValue) => handleChange('emailaddress', newValue)}
                  disabled={isViewMode}
                  error={errors.emailaddress}
                  errorMessage={errorMessages.emailaddress}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={20}
                  label="Fax No"
                  id="fax-no"
                  value={faxno}
                  onChange={(newValue) => handleChange('faxno', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={40}
                  label="Branch Manager"
                  id="branch-manager"
                  value={branchmanager}
                  onChange={(newValue) => handleChange('branchmanager', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={20}
                  label="Handphone No"
                  id="handphone-no"
                  value={handphoneno}
                  onChange={(newValue) => handleChange('handphoneno', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={20}
                  label="Telephone No"
                  id="telephone-num"
                  value={telephonenum}
                  onChange={(newValue) => handleChange('telephonenum', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomTextField
                  maxlength={20}
                  label="Fax No"
                  id="fax-num"
                  value={faxnum}
                  onChange={(newValue) => handleChange('faxnum', newValue)}
                  disabled={isViewMode}
                />
              </Grid>
            </Grid>
          </Box>
        </form>

      </DefaultCard>
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        title="Error"
        content="No Hospital Information found."
        confirmBtn="OK"
        onConfirm={handleDialogConfirm}
      />
      <CustomDialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        content={succesDialogMessage}
        confirmBtn="OK"
        onConfirm={() => setSuccessDialogOpen(false)}
      />
      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        content="Record(s) not Saved/Updated. Do you want to continue?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleCancelDialogConfirm}
        onCancel={handleCancelDialogClose}
      />
      {isViewMode ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
            Back
          </Button>
        </Box>

      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="contained" color="primary" sx={{ m: 1 }} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
            Back
          </Button>
        </Box>
      )}
    </TabContentLayout>
  );
}

export default HospitalInformationContent;
